import { FC } from 'react';

import { Flex } from 'src/components/Flex';

import { ComplianceCard, SectionCard } from '../../components';
import { CARDS } from '../TransactionPricing';

interface CompliancePricing {
    name: string;
    notAdminUser?: boolean;
}

export const WORLDPAY_OPTIONS: CARDS[] = [
    {
        heading: 'SaferPayments Programme Fee',
        note: 'The standard SaferPayments Programme Fee will be charged Unless and until you upload a current compliance from another Qualified Security Assessor (QSA)',
        name: 'saferPaymentsProgrammeFee',
        tooltip: 'This is a monthly charge for our standard PCI DSS compliance programme.',
    },
];

export const SAFE_PAYMENTS_OPTIONS: CARDS[] = [
    {
        heading: 'SaferPayments PCI DSS Non-compliance charge',
        name: 'nonComplianceCharge',
        tooltip:
            'You will receive this charge if you fail to (and until you) certify your PCI DSS compliance with Worldpay.',
    },
    {
        heading: 'SaferPayments Vulnerability Scan Fee',
        name: 'vulnerabilityScanFee',
        note: 'Vulnerability Scan Fee is a once off fee, or inclusive within SaferPayments Plus.',
        tooltip: 'This will be identified during the certification process.',
    },
    {
        heading: 'SaferPayments Plus Managed Service Fee',
        name: 'plusManagedServiceFee',
        note: 'We will call you to confirm your subscription. The service is subject to a separate application and boarding process, and  separate terms and conditions. Further information is available at: www.worldpay.com/saferpaymentsplus',
        tooltip: 'This will be applied should you chose to subscribe to take the managed service.',
    },
];

export const CompliancePricing: FC<CompliancePricing> = ({ name, notAdminUser }) => {
    return (
        <Flex flexDirection="column" gap="24px">
            <SectionCard heading="Worldpay's SaferPayments (PCI DSS compliance) Programme">
                {WORLDPAY_OPTIONS.map((option, index) => (
                    <ComplianceCard
                        key={option.name}
                        namePrefix={`${name}.worldpayProgramme.${option.name}`}
                        heading={option.heading}
                        isOdd={index % 2 === 0}
                        note={option.note}
                        tooltip={option.tooltip}
                        isConstant={option.isConstant || notAdminUser}
                    />
                ))}
            </SectionCard>
            <SectionCard heading="Additional Charges">
                {SAFE_PAYMENTS_OPTIONS.map((option, index) => (
                    <ComplianceCard
                        key={option.name}
                        namePrefix={`${name}.safePayments.${option.name}`}
                        heading={option.heading}
                        isOdd={index % 2 === 0}
                        note={option.note}
                        tooltip={option.tooltip}
                        isConstant={option.isConstant || notAdminUser}
                    />
                ))}
            </SectionCard>
        </Flex>
    );
};
